export const MEMBER_CLASSES = [
    { label: 'Consumatore', value: 'consumer' },
    { label: 'Produttore', value: 'producer' },
    { label: 'Prosumer', value: 'prosumer' }
];
